import { LogoWithTitle } from 'pages/our-story/components/LogoWithTitle'
import { UserMarketing } from './data/section7Data'

interface UserMarketingSlideProps extends UserMarketing { }

export const UserMarketingSlide = ({
  title,
  tagline,
  subtitle,
  body,
  image,
}: UserMarketingSlideProps) => {
  return (
    <div className='!px-5 w-[100vw] md:mx-auto md:!px-20 lg:!px-24 xl:!px-30'>
      <LogoWithTitle title={title} />
      <p className='text-sm text-[#37455C] font-medium pt-6 pb-10 3xl:text-lg'>{tagline}</p>
      <div className='flex flex-col lg:flex-row lg:gap-4'>
        <div className='h-[524px] relative lg:h-[372px] xl:h-full'>
          <img
            src={image}
            alt={subtitle}
            className={`h-full max-w-[740px] absolute px-4 -right-4 md:relative md:right-8 md:m-auto xl:h-[460px] xl:max-w-fit 2xl:h-[580px] 3xl:h-[630px]`}
          />
        </div>
        <div className='flex flex-col pr-4'>
          <h5 className='text-sm text-[#001A3D] font-medium py-3 lg:!py-0 lg:mb-3 xl:text-lg 3xl:text-xl'>
            {subtitle}
          </h5>
          <p className='text-xs text-[#001A3D] font-normal leading-4 tracking-[0.4px] xl:text-sm 3xl:text-base'>
            {body}
          </p>
        </div>
      </div>
    </div>
  )
}
